<template>
  <tr>
    <td>{{row["key"]}}</td>
    <td v-for="(l,i) in $parent.languages" :key="i">{{row[l]}}</td>
    <td>
      <Loader :id="row['key']" />
    </td>
  </tr>
</template>
<script>
import Loader from "./CheckMarkLoader";
export default {
  name: "SystemSettingsItem",
  props: {
    row: Object,
  },
  components: {
    Loader,
  },
  data() {
    return {};
  },
  methods: {
    markComplete() {
      this.$parent.processPercent += this.$parent.step;
      var id = this.row["key"];
      var circle = document.getElementById("circle-" + id);
      var check = document.getElementById("checkmark-" + id);
      circle.classList.add("load-complete");
      check.style.display = "block";
    },
    postSetting() {
      var translations = [];
      this.$parent.languages.forEach((l) => {
        var lID = this.$parent.langID[l];
        var text = this.row[l];
        if (lID && text) {
          var translation = { text: text.toString(), language: lID };
          translations.push(translation);
        }
      });
      var setting = {
        key: this.row["key"],
        phrase: {
          translations: translations,
          attachments: null,
        },
      };
      if (translations.length && this.row["key"]) {
        this.$http.post("/settings/applicationtext", setting).then((r) => {
          if(r.data.error_message == "Key already present"){
              this.$http.put("/settings/applicationtext", setting).then(r => {
                  setTimeout(this.markComplete, Math.random() * 10000);
              })
          }else{
              setTimeout(this.markComplete, Math.random() * 10000);
          }
        });
      } else {
        this.markComplete();
      }
    },
  },
  mounted() {
    this.postSetting();
  },
};
</script>
<style scoped>
</style>